import { apiBaseURL } from "../ProjectConstants";
import handleBackendResponse from "../handleNotifications/handleBackendResponse";

async function handleDelPOComment(orderId, commentId, fetch) {
  const response = await fetch.delete(
    `${apiBaseURL}/api/PurchaseOrder/Comments?orderId=${orderId}&commentId=${commentId}`,
  );
  //const isDataGood = response?.success && response?.data?.statusCode && response?.success !== 'Invalid Model';
  const isDataGood = handleBackendResponse(response);

  console.log("handleDelPOComment commentId", commentId);
  console.log("handleDelPOComment response", response);

  return {
    response,
    isDataGood,
  };
}
export default handleDelPOComment;
